<template>
  <div id="app">
    <verify-email v-if="modal == 'VerifyEmailAlert' && isLoggedIn"></verify-email>
    <complete-profile v-if="modal == 'CompleteProfileAlert' && isLoggedIn"></complete-profile>
    <!-- <jobseeker-evaluation v-if="modal == 'JobSeekerEvaluation' && isLoggedIn"></jobseeker-evaluation> -->
    <div id="modal" class="r-isfull-position"  v-if="updateExists">
        <div class="r-modal-box r-mtb-20-withauto">
            <div class="r-modal-form r-p-25 r-center-text" >
                <h4 class="r-mb-16">Pembaruan Tersedia </h4>
                <p>
                    Demi kenyamanan kamu, kami terus melakukan perbaikan agar website ini semakin baik.
                </p>
                <p class="r-mtb-16 ">
                  Klik tombol dibawah ini untuk mendapatkan pembaruan.
                </p>
                <button class="r-isExpand r-primary-filled-btn r-large-size r-mtb-16" @click.prevent="refreshApp()">
                    Perbarui Sekarang
                </button>
            </div>
        </div>
    </div>
    <main>
      <transition name="slide-fade" mode="out-in">
        <router-view />
      </transition>
    </main>
    <div class="isDemo r-primary-alert" v-if="isDemo == 1">
      DEMO ONLY
    </div>
    <p style="display: none"> {{ $route.name }}</p>
    <r-snackbar />
  </div>
</template>
<script>
import RSnackbar from '@/components/main/snackbar.vue'
import VerificationEmailModal from '@/components/modal/VerificationEmailModal.vue'
import CompleteProfileAlert from '@/components/modal/CompleteProfileAlert.vue'
import update from './mixins/update'
import { mapGetters, mapActions} from 'vuex'

export default {
  components: {
    "r-snackbar": RSnackbar,
    "verify-email": VerificationEmailModal,
    "complete-profile": CompleteProfileAlert,
  },
  data: () =>({
    // loading: true,
    isDemo: process.env.VUE_APP_IS_DEMO
  }),
  computed:{
    ...mapGetters({
      modal: 'getModal',
      isLoggedIn: 'getisLoggedIn'
    }),
  },
  mixins: [update],
  mounted(){
    this.setIsMobile(window.innerWidth)
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  methods: {
    ...mapActions({
      setIsMobile: 'setIsMobile',
    }),
    onResize() {
      this.setIsMobile(window.innerWidth)
    },
  }
}
</script>